const en = {
  common: {
    home: "Home",
    aboutBrand: "About brand",
    contactUs: "Contact us",
    products: "Products",
  },

  home: {
    title: "VALMIS DE LUXE",
    subtitle: "The leader of the Ukrainian canned fish market",
    contactUs: "Contact us",
    aboutBrand: "About brand",
  },

  footer: {
    contact: "Contact",
    newsletterTitle: "Never miss a possibility to cooperate",
    emailPlaceholder: "Email address",
    contactUs: "Contact us",
    copyright: "© 2026 Valmis. All rights reserved",
  },

contact: {
  title: "Contact us",
  subtitle: "We are happy to hear from potential partners.",

  name: "Full name *",
  company: "Company",
  email: "Email address *",
  phone: "Phone number",
  message: "Your message",

  submit: "Send message",

  success: "Message sent successfully!",
  error: "Failed to send message. Please try again.",

  purpose: {
    partnership: "Partnership",
    supply: "Supply proposal",
    distribution: "Distribution",
    general: "General inquiry",
  },
},

about: {
  hero: {
    title: "VALMIS DE LUXE",
    subtitle: "The leader of the Ukrainian canned fish market",
  },

  achievements: {
    title: "Our achievements",
    item1: "The largest importer of canned fish in Ukraine",
    item2: "Strong presence in national retail chains and distributors",
    item3: "Impeccable reputation among partners and customers",
  },

  mission: {
    title: "Our mission",
    text: () => (
      <>
        To provide <strong>affordable</strong> and
        <strong className="highlight-text"> high-quality products</strong>,
        preserving <strong>traditions</strong> and applying modern technologies.
      </>
    ),
  },

  products: {
    title: "Products and brands",
    subtitle: "We import over 40 types of canned products:",
    list: () => (
                <>
                  🐟 Canned fish from the Baltic states 🇪🇪🇱🇻🇱🇹 <br />
                  🍍 Fruits from Thailand 🇹🇭 <br />
                  🥩 Meat products from Poland 🇵🇱 <br />
                  🫒 Olives from Spain 🇪🇸
                </>
              ),
    brands: "Our brands:",
  },

  video: {
    title: "It looks DE LUXE",
    subtitle: "Experience the taste of tradition in every bite",
    muted: "Mute",
    unmuted: "Unmute"
  },

  testimonials: {
    title: "Customer testimonials",
        subtitle: () => (
                <>
                  Only the best <br /> for our clients
                </>
              ),
    text1: "VALMIS DE LUXE is the best supplier we have worked with.",
    text2: "High-quality products and always on-time deliveries.",
  },

  advantages: {
    title: "Our advantages",
    item1: "15 years on the market — a reliable partner",
    item2: "100% order fulfillment",
    item3: "Fast processing and delivery",
    item4: "Individual approach to every client",
  },

  cooperation: {
    text: "We value our partners and are always open to long-term, mutually beneficial cooperation!",
  },
},

juice: {
  title: "Juice",
  products: {
    lemon: {
      title: "Lemon Juice (Seasoning)\nLemoni",
      weight: "220 ml | Bottle",
      description: "Packing: 15 pcs | 156 boxes/pallet",
    },
    lime: {
      title: "Lime Juice (Seasoning)\nLemoni",
      weight: "220 ml | Bottle",
      description: "Packing: 15 pcs | 156 boxes/pallet",
    },
  },
},

pineapple: {
  title: "Pineapples",
  products: {
    valmisRings: {
      title: "Pineapple Rings in Syrup\nVALMIS",
      weight: "580 ml | Tin",
      description: "Packing: 24 pcs | 45 boxes/pallet",
    },
    valmisChunks: {
      title: "Pineapple Chunks in Syrup\nVALMIS",
      weight: "580 ml | Tin",
      description: "Packing: 24 pcs | 45 boxes/pallet",
    },
    ananasoffRings: {
      title: "Pineapple Rings in Syrup\nANANASOFF",
      weight: "580 ml | Tin",
      description: "Packing: 24 pcs | 45 boxes/pallet",
    },
    ananasoffChunks: {
      title: "Pineapple Chunks in Syrup\nANANASOFF",
      weight: "580 ml | Tin",
      description: "Packing: 24 pcs | 45 boxes/pallet",
    },
  },
},

olive: {
  title: "Olives",
  products: {
    black425: {
      title: "Black Pitted Olives\nOlive Land",
      weight: "425 ml | Tin",
      description: "Packing: 12 pcs | 144 boxes/pallet",
    },
    black300: {
      title: "Black Pitted Olives\nOlive Land",
      weight: "300 ml | Tin",
      description: "Packing: 12 pcs | 196 boxes/pallet",
    },
    green300: {
      title: "Green Pitted Olives\nOlive Land",
      weight: "300 ml | Tin",
      description: "Packing: 12 pcs | 196 boxes/pallet",
    },
  },
},

tuna: {
  title: "Tuna",
  products: {
    valmisWholeOil: {
      title: "Whole Tuna in Oil\nVALMIS DE LUXE",
      weight: "150 g | Tin",
      description: "Packing: 24 pcs | 150 boxes/pallet",
    },
    valmisWholeBrine: {
      title: "Whole Tuna in Brine\nVALMIS DE LUXE",
      weight: "150 g | Tin",
      description: "Packing: 24 pcs | 150 boxes/pallet",
    },
    valmisSaladOil: {
      title: "Tuna Salad in Oil\nVALMIS",
      weight: "150 g | Tin",
      description: "Packing: 24 pcs | 150 boxes/pallet",
    },
    valmisSaladBrine: {
      title: "Tuna Salad in Brine\nVALMIS",
      weight: "150 g | Tin",
      description: "Packing: 24 pcs | 150 boxes/pallet",
    },

    tuncoffWholeOil: {
      title: "Whole Tuna in Oil\nTUNCOFF",
      weight: "150 g | Tin",
      description: "Packing: 24 pcs | 150 boxes/pallet",
    },
    tuncoffWholeBrine: {
      title: "Whole Tuna in Brine\nTUNCOFF",
      weight: "150 g | Tin",
      description: "Packing: 24 pcs | 150 boxes/pallet",
    },
    tuncoffSaladOil: {
      title: "Tuna Salad in Oil\nTUNCOFF",
      weight: "150 g | Tin",
      description: "Packing: 24 pcs | 150 boxes/pallet",
    },
    tuncoffSaladBrine: {
      title: "Tuna Salad in Brine\nTUNCOFF",
      weight: "150 g | Tin",
      description: "Packing: 24 pcs | 150 boxes/pallet",
    },
  },
},


canned: {
  title: "Canned Fish",

  sprats: {
    title: "Sprats",
    description: "Classic Riga-style, Gdansk-style and DeLuxe sprats.",
  },

  atlantic: {
    title: "Atlantic",
    description: "Mackerel, sardines, pink salmon and salmon.",
  },

  tomato: {
    title: "Tomato Group",
    description: "Sprats, sardines and mackerel in tomato sauce.",
  },

  liver: {
    title: "Cod Liver",
    description: "Premium, TL and classic formats.",
  },
},

sprats: {
  title: "Sprats",

  products: {

    sprats_valmis_deluxe_tl_240: {
      title: "Sprats in Oil (DeLuxe, TL)\nVALMIS",
      weight: "240 g | Tin TL",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },
    
    valmis_deluxe_glass_250: {
      title: "Sprats in Oil (DeLuxe, Glass)\nVALMIS",
      weight: "250 g | Glass jar",
      description: "Packing: 12 pcs | 144 cases/pallet",
    },

    valmis_gdansk_170: {
      title: "Sprats in Oil, Gdansk Style\nVALMIS",
      weight: "170 g | Easy open",
      description: "Packing: 28 pcs | 128 cases/pallet",
    },

    valmis_riga_160: {
      title: "Riga Sprats in Oil\nVALMIS",
      weight: "160 g | Easy open",
      description: "Packing: 36 pcs | 96 cases/pallet",
    },

    valmis_riga_240: {
      title: "Riga Sprats in Oil\nVALMIS",
      weight: "240 g | Easy open",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },

    ventspils_160: {
      title: "Sprats in Oil\nVentspils",
      weight: "160 g | Easy open",
      description: "Packing: 36 pcs | 96 cases/pallet",
    },

    ventspils_240: {
      title: "Sprats in Oil\nVentspils",
      weight: "240 g | Easy open",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },

    ventspils_tl_240: {
      title: "Sprats in Oil\nVentspils",
      weight: "240 g | Tin TL",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },

    ventspils_190: {
      title: "Sprats in Oil\nVentspils",
      weight: "190 g | Easy open",
      description: "Packing: 36 pcs | 85 cases/pallet",
    },
  },
},

atlantic: {
  title: "Atlantic",

  products: {
    valmis_sardine_oil_240: {
      title: "Sardines in Oil\nVALMIS DeLuxe",
      weight: "240 g | Tin",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },
    valmis_mackerel_oil_240: {
      title: "Mackerel in Oil\nVALMIS DeLuxe",
      weight: "240 g | Tin",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },
    valmis_pink_salmon_natural_240: {
      title: "Pink Salmon, Natural\nVALMIS DeLuxe",
      weight: "240 g | Tin",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },
    valmis_salmon_juice_240: {
      title: "Salmon in Own Juice\nVALMIS",
      weight: "240 g | Tin",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },

    baltic_riga_sardine_oil_240: {
      title: "Riga Sardines in Oil\nBaltic Sea",
      weight: "240 g | Tin",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },
    ventspils_riga_sardine_oil_240: {
      title: "Riga Sardines in Oil\nVentspils",
      weight: "240 g | Tin",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },
    ventspils_mackerel_oil_240: {
      title: "Atlantic Mackerel in Oil\nVentspils",
      weight: "240 g | Tin",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },
    ventspils_pink_salmon_natural_240: {
      title: "Pink Salmon, Natural\nVentspils",
      weight: "240 g | Tin",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },
  },
},

tomato: {
  title: "Tomato Group",

  products: {
    valmis_kilka_fried_240: {
      title: "Fried Sprats in Tomato Sauce\nVALMIS DeLuxe",
      weight: "240 g | Tin",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },
    valmis_chopped_fish_240: {
      title: "Chopped Fish in Tomato Sauce\nVALMIS",
      weight: "240 g | Tin",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },

    ventspils_riga_sardine_240: {
      title: "Riga Sardines in Tomato Sauce\nVentspils",
      weight: "240 g | Tin",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },
    ventspils_mackerel_240: {
      title: "Mackerel in Tomato Sauce\nVentspils",
      weight: "240 g | Tin",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },
    ventspils_chopped_fish_240: {
      title: "Chopped Fish in Tomato Sauce\nVentspils",
      weight: "240 g | Tin",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },
    ventspils_kilka_fried_240: {
      title: "Fried Sprats in Tomato Sauce\nVentspils",
      weight: "240 g | Tin",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },
    ventspils_kilka_fried_190: {
      title: "Fried Sprats in Tomato Sauce\nVentspils",
      weight: "190 g | Tin",
      description: "Packing: 36 pcs | 85 cases/pallet",
    },
  },
},

liver: {
  title: "Cod Liver",

  products: {
    valmis_tl_230: {
      title: "Cod Liver (TL)\nVALMIS DeLuxe",
      weight: "230 g | Tin TL",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },
    valmis_121: {
      title: "Cod Liver\nVALMIS DeLuxe",
      weight: "121 g | Tin",
      description: "Packing: 12 pcs | 391 cases/pallet",
    },
    valmis_tl_115: {
      title: "Cod Liver (TL)\nVALMIS DeLuxe",
      weight: "115 g | Tin TL",
      description: "Packing: 12 pcs | 391 cases/pallet",
    },
    valmis_230: {
      title: "Cod Liver\nVALMIS DeLuxe",
      weight: "230 g | Tin",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },

    baltic_230: {
      title: "Cod Liver\nBaltic Sea PREMIUM",
      weight: "230 g | Tin",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },
    baltic_tl_230: {
      title: "Cod Liver (TL)\nBaltic Sea PREMIUM",
      weight: "230 g | Tin TL",
      description: "Packing: 24 pcs | 96 cases/pallet",
    },
    baltic_121: {
      title: "Cod Liver\nBaltic Sea PREMIUM",
      weight: "121 g | Tin",
      description: "Packing: 12 pcs | 391 cases/pallet",
    },
  },
},


};

export default en;
